import type { UpdateEvaluationRequest } from '@compass/client/types/evaluation';
import { evaluationService } from '@services/api';
import { queryKeys } from '@services/query.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useUpdateEvaluation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateEvaluationRequest) => evaluationService.updateEvaluation(request),
    onSuccess: (_data, variables) => {
      if (variables.evaluation_id) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.evaluations.byId(variables.evaluation_id),
        });
      }
      // Invalidate list/count queries so the Needs Review tab count updates
      queryClient.invalidateQueries({
        queryKey: queryKeys.evaluations.all,
      });
    },
    onError: (error: Error) => {
      console.error('Evaluation review update failed:', error);
      toast.error('Failed to submit review. Please try again.');
    },
  });
};
